import React from 'react';
import { Loader2 } from 'lucide-react';

const cardStyle = { width: '100%', maxWidth: 440, textAlign: 'center', backgroundColor: '#FFFFFF', border: '1px solid #E0E0E0', borderRadius: 12, padding: 'clamp(24px, 6vw, 36px) clamp(20px, 6vw, 32px)', boxShadow: 'var(--shadow-md)' };
const wrapStyle = { display: 'flex', justifyContent: 'center', padding: 'clamp(16px, 5vw, 48px) 16px' };

// Spinner card shown while the verification status is being loaded.
export const PageLoading = () => (
  <div style={wrapStyle}>
    <div role="status" aria-live="polite" style={{ ...cardStyle, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 12, color: '#666666', fontSize: 14 }}>
      <Loader2 size={22} color="#E53935" className="animate-spin" aria-hidden="true" />
      <span>Načítám modul Zásilky…</span>
    </div>
  </div>
);

// Centered message card (no access, load failure): icon, title, text and an optional action.
export const MessageCard = ({ icon, tone = '#E53935', toneBg = '#FFEBEE', title, children, action }) => {
  const Icon = icon; // capitalised local, so the plain no-unused-vars rule sees the JSX use
  return (
    <div style={wrapStyle}>
      <section aria-labelledby="shipments-message-title" style={cardStyle}>
        <div aria-hidden="true" style={{ width: 56, height: 56, borderRadius: '50%', backgroundColor: toneBg, display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 16px' }}>
          <Icon size={26} color={tone} />
        </div>
        <h1 id="shipments-message-title" style={{ fontSize: 22, fontWeight: 700, letterSpacing: 0, color: '#333333', margin: '0 0 8px' }}>{title}</h1>
        <p style={{ fontSize: 14, color: '#666666', margin: action ? '0 0 20px' : 0, lineHeight: 1.5 }}>{children}</p>
        {action}
      </section>
    </div>
  );
};
